import React from 'react'
import { connect } from 'react-redux'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import uniCc01 from '../../images/uni-cc-01.png'
import uniCc02 from '../../images/uni-cc-02.png'
import uniCc03 from '../../images/uni-cc-03.png'
import uniCc04 from '../../images/uni-cc-04.png'
import uniCc05 from '../../images/uni-cc-05.png'
import uniCc06 from '../../images/uni-cc-06.png'
import { usersGetDetailAsync } from '../../actions/users.js'
import { accesslog, translate } from '../../helpers/global.js'
import { Link } from 'react-router-dom'

class UniCareer extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {
    const { globalGetLanguages } = this.props;
    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="section-top-solution relative bg-gray" style={{
          position: 'relative',
          paddingTop: '120px',
        }}>
          <div className="gray-curve-bottom-left"></div>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <div className="sec-desc">
                  <h1>
                    Transform How You Support Students from Campus to Career
                  </h1>
                  <p className='text-normal-2'>
                    ASTRNT helps universities build a smart, digital Career Center platform. It is fully branded, free to use, and designed to deliver real outcomes.
                  </p>
                  <br />
                  <div className={`ban-link`} style={globalGetLanguages == 'id' ? {margin: '0'} : {margin: '8px 0 0'}}>
                    <a onClick={() => {
                      document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                      accesslog('career-center', 'button_talk_to_an_expert');
                    }} className="request-demo-logged">{translate(globalGetLanguages,'HOMEPAGE_BUTTON_REQUEST_DEMO')}</a>
                  </div>
                </div>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={uniCc01} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-right flex-container flex-end align-items-center p-r-20'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={uniCc02} />
              </div>
            </div>
            <div className='flex-item-left'>
              <div className='vertical-item--center' style={{
                paddingLeft: '110px',
              }}>
                <h1 className='title-2'>
                  A Complete Platform for Career Services
                </h1>
                <p className='sub-title-1'>
                  More than a jobs board. It becomes a central space for students, employers, and career development teams to interact, grow, and prepare for the world of work.
                </p>
                <ul className='list-1 m-t-25'>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        Manage jobs, internships, scholarships, and career events
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        Track student engagement and graduate outcomes
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        Collaborate with employers and industry partners
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <i className="fas fa-check check-white-green" />
                      <p className='text-normal-1'>
                        Enable student self-preparation using ASTRNT’s built-in tools
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center'
                style={{
                  padding: '0 60px',
                }}
              >
                <div className="sec-desc">
                  <h2 style={{fontWeight:'700'}}>
                    Help Students Get Ready Before They Apply
                  </h2>
                  <p>
                    Support students with tools that build confidence and clarity
                  </p>
                  <ul className="m-b-32 m-t-30">
                    <li><i className="fas fa-check" />Interview simulations</li>
                    <li><i className="fas fa-check" />Career readiness self-assessments</li>
                    <li><i className="fas fa-check" />Online workshops and learning content</li>
                    <li><i className="fas fa-check" />Personal dashboards that show strengths and role matches</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={uniCc03} />
              </div>
            </div>
          </section>
        </div>
        <div className="curved-shape" style={{top:'2200px'}}></div>
        <div className="section-white" style={{overflow: 'hidden', position: 'relative'}}>
          <section className='flex-container' style={{zIndex: '2', position: 'relative'}}>
            <div className='flex-item-right flex-container flex-end align-items-center flex-padding-1'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={uniCc04} />
              </div>
            </div>
            <div className='flex-item-left flex-padding-1 p-l-30'>
              <div className='vertical-item--center'>
                <div className="sec-desc">
                  <h2 style={{fontWeight:'700'}}>
                    Make It Easy for Employers to Join
                  </h2>
                  <p className='text-justify'>
                    Let employers discover and connect with your students directly through the platform.
                  </p>
                  <ul className="m-b-32 m-t-30">
                    <li><i className="fas fa-check" />Post and manage job openings</li>
                    <li><i className="fas fa-check" />Access structured student profiles</li>
                    <li><i className="fas fa-check" />Participate in career events or webinars</li>
                    <li><i className="fas fa-check" />Review applicant results with ASTRNT platform</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden', position: 'relative'}}>
          <section className='flex-container' style={{zIndex: '2', position: 'relative'}}>
            <div className='flex-item-left flex-padding-1 p-l-30'>
              <div className='vertical-item--center'>
                <div className="sec-desc">
                  <h2 style={{fontWeight:'700'}}>
                    Support Career Fair Planning and Execution
                  </h2>
                  <p className='text-justify'>
                    Our partners help you run online career fairs with less manual work. All activity, from registration to reporting, stays in one place.
                  </p>
                  <ul className="m-b-32 m-t-30">
                    <li><i className="fas fa-check" />Employer onboarding and event calendar</li>
                    <li><i className="fas fa-check" />Student registration and job matching</li>
                    <li><i className="fas fa-check" />Live session and webinar management</li>
                    <li><i className="fas fa-check" />Post-event summary and analytics</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center flex-padding-1'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={uniCc05} />
              </div>
            </div>

          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-right flex-container flex-end align-items-center flex-padding-1'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={uniCc06} />
              </div>
            </div>
            <div className='flex-item-left flex-padding-1 p-l-30'>
              <div className='vertical-item--center'>
                <div className="sec-desc">
                  <h2 style={{fontWeight:'700'}}>
                    Fully Branded for Your Institution
                  </h2>
                  <p className='text-justify'>
                    Every platform reflects your identity. Use your university logo, colors, and content. And with our no-code interface adjust everything without technical help.
                  </p>
                  <ul className="m-b-32 m-t-30">
                    <li><i className="fas fa-check" />Flexible layout templates</li>
                    <li><i className="fas fa-check" />Simple content manager</li>
                    <li><i className="fas fa-check" />Free onboarding and support from our team</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="section-white bg-gray center"
          style={{
            textAlign: '-webkit-center',
            minHeight: '366px',
            padding: '56px 0',
            position: 'relative',
          }}
        >
          <div className='gray-triangle-bottom-right'>
            <div className='gray-small-triangle-bottom-right'></div>
          </div>
          <div>
            <h1 className='title-1'>
              Trusted by Career Centers
              <br />
              Across Indonesia
            </h1>
            <p style={{
              margin: '20px 0',
            }}>
              From CDC UI and across Indonesia, leading universities use ASTRNT’s tools to modernize
              <br />
              how they support students and connect with employers.
            </p>
            <div>
              <a className='btn btn-primary-red' onClick={() => {
                document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                accesslog('career-center', 'button_talk_to_an_expert');
              }}>
                Talk to an Expert
              </a>
            </div>
          </div>
        </div>
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UniCareer)
